import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { styled } from '@compiled/react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import TrashIcon from '@atlaskit/icon/core/delete';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import type { TrashButtonProps } from './types.ts';
import { i18n } from './i18n.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TrashButtonWrapper = styled.div({
	width: '16px',
	height: '16px',
	cursor: 'pointer',
});

const TrashButtonComponent = ({
	spaceKey,
	color,
	name,
	id,
	setIsTrashHovered,
	removeState,
	intl: { formatMessage },
}: TrashButtonProps) => {
	const [isHovered, setIsHovered] = useState<boolean>(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onHover = () => {
		setIsHovered(true);
		setIsTrashHovered(true);
	};

	const onLeave = () => {
		setIsHovered(false);
		setIsTrashHovered(false);
	};

	const onClick = () => {
		removeState(color || '', name || '', id || '');
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				objectId: spaceKey,
				actionSubjectId: 'adminRemovedContentState',
				source: 'contentStateAdminSettings',
			},
		}).fire();
	};

	return (
		<Tooltip content={formatMessage(i18n.remove)} position="top">
			<TrashButtonWrapper
				data-testid="trash-button-wrapper"
				onMouseOver={onHover}
				onMouseOut={onLeave}
				onClick={onClick}
			>
				<TrashIcon
					label="remove-icon"
					color={isHovered ? token('color.icon.danger') : token('color.icon.subtle')}
				/>
			</TrashButtonWrapper>
		</Tooltip>
	);
};

export const TrashButton = injectIntl(TrashButtonComponent);
